import buildAndSubmitForm from './buildAndSubmitForm';

export default function logout() {
    buildAndSubmitForm('/ui/logout');
}
